<template>
  <div class="py-2">
    <label class="block pr-4 text-lg font-medium" :for="id">{{label}}</label>
    <select
      @change="updateValue($event.target.value)"
      @load="updateValue($event.target.value)"
      :class="{ 'border-red-500': error }"
      class="w-full p-2 border rounded outline-none focus:outline-none"
      :id="id"
    >
      <option v-for="option in options" :key="option" :selected="option === value">

        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'dropDown',
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    updateValue(newValue) {
      this.$emit('update:value', newValue);
    },
  },
  watch: {
    options: {
      handler(newVal) {
        if (newVal[0] !== this.value) {
          this.updateValue(newVal[0]);
        }
      },
    },
  },
  mounted() {

  },
};
</script>
